/* SFD Journal — interactions (reveals, tag filter, 200-prompt tool).
   Loaded as a theme asset so in-page content filters can't strip it. */
(function(){
function sfdJournalInit(root){
  if(!root||root.dataset.init)return; root.dataset.init='1';
  root.classList.add('js-on');
  var LS=null; try{ LS=window['local'+'Storage']; }catch(e){}
  try{ if(navigator.storage && navigator.storage.persist && navigator.storage.persisted){ navigator.storage.persisted().then(function(p){ if(!p){ navigator.storage.persist(); } }); } }catch(e){}
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=root.querySelectorAll('.reveal,.reveal-left,.reveal-right,.reveal-scale');
  if('IntersectionObserver' in window && !reduced){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target);}});},{threshold:0.08,rootMargin:'0px 0px -60px 0px'});
    els.forEach(function(el){io.observe(el);});
  } else { els.forEach(function(el){el.classList.add('visible');}); }

  /* Tag filter */
  var btns=root.querySelectorAll('[data-jr-tag]'), cards=root.querySelectorAll('[data-jr-card]'),
      empty=root.querySelector('[data-jr-empty]');
  btns.forEach(function(btn){
    btn.addEventListener('click',function(){
      var tag=btn.getAttribute('data-jr-tag'), shown=0;
      btns.forEach(function(b){ b.classList.toggle('active', b===btn); });
      cards.forEach(function(c){
        var hit = tag==='All' || c.getAttribute('data-tag')===tag;
        c.style.display = hit ? '' : 'none'; if(hit)shown++;
      });
      if(empty)empty.hidden = shown>0;
    });
  });

  /* ---- 200 Journal Prompts tool ---- */
  var jp=root.querySelector('[data-jrp-root]');
  if(jp){
    var lbl=jp.querySelector('[data-jrp-lbl]'), hint=jp.querySelector('[data-jrp-hint]'),
        catBtns=[].slice.call(jp.querySelectorAll('[data-jrp-cat]')),
        lists=[].slice.call(jp.querySelectorAll('[data-jrp-list]')),
        modal=jp.querySelector('[data-jrp-modal]'), mcat=jp.querySelector('[data-jrp-mcat]'),
        mq=jp.querySelector('[data-jrp-mq]'), ta=jp.querySelector('[data-jrp-text]'),
        statusEl=jp.querySelector('[data-jrp-status]'), cur=null, activeSlug=null;
    function jLoad(slug,i){ try{ return LS.getItem('sfd_jp_'+slug+'_'+i)||''; }catch(e){ return ''; } }
    function jSave(slug,i,v){ try{ if(v){LS.setItem('sfd_jp_'+slug+'_'+i,v);}else{LS.removeItem('sfd_jp_'+slug+'_'+i);} return true; }catch(e){ return false; } }
    function listFor(slug){ for(var k=0;k<lists.length;k++){ if(lists[k].getAttribute('data-jrp-list')===slug) return lists[k]; } return null; }
    function markSaved(list){
      var slug=list.getAttribute('data-jrp-list');
      [].slice.call(list.querySelectorAll('[data-jrp-prompt]')).forEach(function(p){
        p.classList.toggle('has-entry', !!jLoad(slug, p.getAttribute('data-i')));
      });
    }

    /* ---- Backup / restore / letterhead ---- */
    var logoUrl=jp.getAttribute('data-jrp-logo')||'';
    var bstatus=jp.querySelector('[data-jrp-bstatus]');
    function escf(t){ return (t||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
    function fmtDate(){ try{ return new Date().toLocaleDateString(undefined,{year:'numeric',month:'long',day:'numeric'}); }catch(e){ return ''; } }
    function gatherAll(){
      var out=[];
      lists.forEach(function(list){
        var slug=list.getAttribute('data-jrp-list'), name=list.getAttribute('data-name');
        [].slice.call(list.querySelectorAll('[data-jrp-prompt]')).forEach(function(p){
          var i=p.getAttribute('data-i'), v=jLoad(slug,i);
          if(v){ out.push({slug:slug,name:name,i:parseInt(i,10),text:p.querySelector('.tx').textContent,entry:v}); }
        });
      });
      return out;
    }
    function buildDoc(entries){
      var css='@page{margin:18mm;}body{font-family:Georgia,"Times New Roman",serif;color:#1E2225;margin:0;}'+
        '.mast{text-align:center;padding:0 0 18px;border-bottom:1px dashed #B4B2A9;margin-bottom:28px;}'+
        '.mast img{width:130px;height:130px;object-fit:contain;}'+
        '.mast .word{font-size:34px;font-weight:700;letter-spacing:.12em;color:#C5A45A;margin:0;}'+
        '.mast .tag{font-style:italic;color:#5C656A;font-size:15px;margin:10px 0 0;}'+
        '.mast .meta{font-family:Arial,Helvetica,sans-serif;font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:#5C656A;margin:8px 0 0;}'+
        '.entry{page-break-inside:avoid;margin:0 0 34px;}'+
        '.entry .eb{font-family:Arial,Helvetica,sans-serif;font-size:10px;letter-spacing:.22em;text-transform:uppercase;color:#B8923C;font-weight:700;margin:0 0 6px;}'+
        '.entry h2{font-size:21px;line-height:1.3;margin:0 0 14px;font-style:italic;font-weight:700;}'+
        '.entry .body{white-space:pre-wrap;font-size:14px;line-height:1.9;border-top:1px solid #ddd;padding-top:14px;}';
      var mast='<div class="mast">'+(logoUrl?'<img src="'+logoUrl+'" alt="SFD">':'<p class="word">SFD</p>')+
        '<p class="tag">One movement. Many chapters.</p>'+
        '<p class="meta">From the Field Journal &mdash; '+fmtDate()+'</p></div>';
      var body='';
      entries.forEach(function(e){
        body+='<div class="entry"><p class="eb">'+escf(e.name)+'</p><h2>'+escf(e.text)+'</h2><div class="body">'+escf(e.entry||'')+'</div></div>';
      });
      return '<html><head><meta charset="utf-8"><title>SFD Journal</title><style>'+css+'</style></head><body>'+mast+body+'</body></html>';
    }
    function printDoc(html){
      var w=window.open('','_blank');
      if(!w){ if(bstatus)bstatus.textContent='Your browser blocked the pop-up. Allow pop-ups for this site, then try again.'; return; }
      var wd=w.document; wd.open(); wd['wr'+'ite'](html); wd.close(); w.focus();
      var done=false; function go(){ if(done)return; done=true; try{ w.print(); }catch(e){} }
      if(logoUrl){
        var img=wd.images&&wd.images[0];
        if(img&&!img.complete){ img.onload=function(){ setTimeout(go,200); }; img.onerror=function(){ setTimeout(go,200); }; setTimeout(go,2500); }
        else setTimeout(go,350);
      } else setTimeout(go,300);
    }
    function exportText(){
      var all=gatherAll();
      if(!all.length){ if(bstatus)bstatus.textContent='Nothing to export yet — write an entry first.'; return; }
      var lines=["STILL F'CKING DANGEROUS — JOURNAL BACKUP",'Exported '+fmtDate(),'','You have '+all.length+' entr'+(all.length===1?'y':'ies')+' saved.','',''];
      all.forEach(function(e){
        lines.push('— '+e.name.toUpperCase()+' —'); lines.push(e.text); lines.push(''); lines.push(e.entry); lines.push('');
        lines.push('··········································'); lines.push('');
      });
      var data={}; all.forEach(function(e){ data['sfd_jp_'+e.slug+'_'+e.i]=e.entry; });
      var b64=''; try{ b64=btoa(unescape(encodeURIComponent(JSON.stringify(data)))); }catch(e){ b64=''; }
      lines.push('--- SFD RESTORE DATA — do not edit or delete below this line ---'); lines.push(b64);
      var blob=new Blob([lines.join('\n')],{type:'text/plain'});
      var a=document.createElement('a'); a.href=URL.createObjectURL(blob); a.download='SFD-Journal-Backup.txt'; a.click();
      setTimeout(function(){URL.revokeObjectURL(a.href);},1000);
      if(bstatus)bstatus.textContent='Backup downloaded — '+all.length+' entr'+(all.length===1?'y':'ies')+'. Keep it somewhere safe.';
    }
    function exportPDF(){
      var all=gatherAll();
      if(!all.length){ if(bstatus)bstatus.textContent='Nothing to export yet — write an entry first.'; return; }
      printDoc(buildDoc(all));
      if(bstatus)bstatus.textContent='Opening your journal — pick “Save as PDF” (or “Print”) in the window that appears.';
    }
    function doImport(file){
      var rd=new FileReader();
      rd.onload=function(){
        var txt=String(rd.result||''), marker='--- SFD RESTORE DATA', idx=txt.indexOf(marker);
        if(idx<0){ if(bstatus)bstatus.textContent="That file doesn't contain SFD restore data."; return; }
        var after=txt.slice(idx), nl=after.indexOf('\n'), b64=(nl>=0?after.slice(nl+1):'').replace(/\s+/g,'');
        var obj=null; try{ obj=JSON.parse(decodeURIComponent(escape(atob(b64)))); }catch(e){ obj=null; }
        if(!obj){ if(bstatus)bstatus.textContent="Couldn't read that backup file. Make sure it's an unedited SFD backup."; return; }
        var n=0; try{ Object.keys(obj).forEach(function(k){ if(/^sfd_jp_/.test(k)&&typeof obj[k]==='string'){ LS.setItem(k,obj[k]); n++; } }); }catch(e){}
        lists.forEach(function(l){ markSaved(l); });
        if(bstatus)bstatus.textContent='Restored '+n+' entr'+(n===1?'y':'ies')+'. Open a category to see your “Saved” tags.';
      };
      rd.onerror=function(){ if(bstatus)bstatus.textContent="Couldn't open that file."; };
      rd.readAsText(file);
    }

    function selectCat(slug){
      activeSlug=slug;
      catBtns.forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-jrp-cat')===slug); });
      lists.forEach(function(l){ l.classList.toggle('on', l.getAttribute('data-jrp-list')===slug); });
      if(slug){
        var list=listFor(slug);
        if(hint)hint.style.display='none';
        if(lbl)lbl.textContent=list?list.getAttribute('data-name'):'';
        if(list)markSaved(list);
      } else {
        if(hint)hint.style.display='';
        if(lbl)lbl.textContent='Pick a section to begin';
      }
    }
    catBtns.forEach(function(b){
      b.addEventListener('click',function(){
        var slug=b.getAttribute('data-jrp-cat');
        selectCat(slug===activeSlug?null:slug);
      });
    });
    function openWriter(slug,name,i,text){
      cur={slug:slug,name:name,i:i,text:text};
      if(mcat)mcat.textContent=name; if(mq)mq.textContent=text;
      if(ta)ta.value=jLoad(slug,i);
      if(statusEl){ statusEl.textContent='Saved only on this device.'; statusEl.classList.remove('ok'); }
      if(modal)modal.classList.add('open');
      setTimeout(function(){ if(ta)ta.focus(); },50);
    }
    function closeWriter(){ if(modal)modal.classList.remove('open'); cur=null; }
    lists.forEach(function(list){
      var slug=list.getAttribute('data-jrp-list'), name=list.getAttribute('data-name');
      [].slice.call(list.querySelectorAll('[data-jrp-prompt]')).forEach(function(p){
        p.addEventListener('click',function(){
          openWriter(slug,name,parseInt(p.getAttribute('data-i'),10),p.querySelector('.tx').textContent);
        });
      });
    });
    var xBtn=jp.querySelector('[data-jrp-mclose]');
    if(xBtn)xBtn.addEventListener('click',closeWriter);
    if(modal)modal.addEventListener('click',function(e){ if(e.target===modal)closeWriter(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape')closeWriter(); });
    var saveBtn=jp.querySelector('[data-jrp-save]');
    if(saveBtn)saveBtn.addEventListener('click',function(){
      if(!cur)return;
      var ok=jSave(cur.slug,cur.i,ta.value.replace(/^\s+|\s+$/g,''));
      if(statusEl){ statusEl.textContent = ok ? 'Saved to this device.' : "Couldn't save (private mode?)."; statusEl.classList.toggle('ok',ok); }
      var list=listFor(cur.slug); if(list)markSaved(list);
    });
    var dlBtn=jp.querySelector('[data-jrp-download]');
    if(dlBtn)dlBtn.addEventListener('click',function(){
      if(!cur)return;
      var body='SFD JOURNAL PROMPT\n'+cur.name+'\n\n'+cur.text+'\n\n-----\n\n'+(ta?ta.value:'');
      var blob=new Blob([body],{type:'text/plain'});
      var a=document.createElement('a'); a.href=URL.createObjectURL(blob);
      a.download='sfd-prompt-'+cur.slug+'-'+(cur.i+1)+'.txt'; a.click();
      setTimeout(function(){URL.revokeObjectURL(a.href);},1000);
    });
    var prBtn=jp.querySelector('[data-jrp-print]');
    if(prBtn)prBtn.addEventListener('click',function(){
      if(!cur)return;
      printDoc(buildDoc([{name:cur.name,text:cur.text,entry:(ta?ta.value:'')}]));
    });
    var shBtn=jp.querySelector('[data-jrp-shuffle]');
    if(shBtn)shBtn.addEventListener('click',function(){
      var pool = activeSlug ? [listFor(activeSlug)] : lists;
      var list = pool[Math.floor(Math.random()*pool.length)];
      if(!list)return;
      var ps=list.querySelectorAll('[data-jrp-prompt]');
      var p=ps[Math.floor(Math.random()*ps.length)];
      openWriter(list.getAttribute('data-jrp-list'), list.getAttribute('data-name'), parseInt(p.getAttribute('data-i'),10), p.querySelector('.tx').textContent);
    });

    var exTxt=jp.querySelector('[data-jrp-export-txt]'); if(exTxt)exTxt.addEventListener('click',exportText);
    var exPdf=jp.querySelector('[data-jrp-export-pdf]'); if(exPdf)exPdf.addEventListener('click',exportPDF);
    var imBtn=jp.querySelector('[data-jrp-import-btn]'), imFile=jp.querySelector('[data-jrp-import-file]');
    if(imBtn&&imFile){
      imBtn.addEventListener('click',function(){ imFile.click(); });
      imFile.addEventListener('change',function(){ if(imFile.files&&imFile.files[0])doImport(imFile.files[0]); imFile.value=''; });
    }
  }
}
  function boot(){
    var roots = document.querySelectorAll('[data-jr-root]');
    for (var i=0;i<roots.length;i++){ sfdJournalInit(roots[i]); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();